module.exports = __webpack_public_path__ + "img/blue_logo.4c73a07c.png";